// src/utils/hierarchyHelpers.js

/**
 * Extract the first available PublicView from hierarchy
 * @param {Object} hierarchy - Company hierarchy
 * @returns {Object|null} - { companyId, factoryId, ouId, ... } or null
 */
export function getFirstPublicView(hierarchy) {
    if (!hierarchy?.factories?.length) return null;

    for (const factory of hierarchy.factories) {
        if (!factory.ous?.length) continue;

        for (const ou of factory.ous) {
            const activePV = ou.publicviews?.find(
                pv => pv.state === 'active' && pv.machines?.length > 0
            );

            if (activePV) {
                return {
                    companyId: hierarchy.id,
                    companyName: hierarchy.name,
                    factoryId: factory.id,
                    factoryName: factory.name,
                    ouId: ou.id,
                    ouName: ou.name,
                    publicview: activePV
                };
            }
        }
    }

    return null;
}

/**
 * Extract the first available Machine from hierarchy
 * @param {Object} hierarchy - Company hierarchy
 * @returns {Object|null} - { companyId, factoryId, ouId, machine } or null
 */
export function getFirstMachine(hierarchy) {
    if (!hierarchy?.factories?.length) return null;

    for (const factory of hierarchy.factories) {
        if (!factory.ous?.length) continue;

        for (const ou of factory.ous) {
            const activeMachine = ou.machines?.find(m => m.state === 'active');

            if (activeMachine) {
                return {
                    companyId: hierarchy.id,
                    companyName: hierarchy.name,
                    factoryId: factory.id,
                    factoryName: factory.name,
                    ouId: ou.id,
                    ouName: ou.name,
                    machine: activeMachine
                };
            }
        }
    }

    return null;
}